import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { ProductFamiliesState } from "../../models/mp-admin/product-families-state";

const initialState: ProductFamiliesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.productFamilies.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.productFamilies.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.productFamilies.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.productFamilies.invalidate, () => initialState)
);

export function productFamiliesReducer(
	state: ProductFamiliesState | undefined,
	action: Action
): ProductFamiliesState {
	return reducer(state, action);
}
